import clsx from 'clsx';

import { TableCell, TableHead, TableRow, Typography } from '@/ui';

import type { CoachColumn, CoachSortBy } from '@/constants/coaches';
import type { SortDirection } from '@/types';
import type { FC } from 'react';

const HIDE_ON_SMALL = new Set(['calendar_url', 'start_date', 'updated_at']);

interface HeaderProps {
  columns: CoachColumn[];
  onSort: (key: CoachSortBy) => void;
  sortBy: CoachSortBy;
  sortDirection: SortDirection;
}

const Header: FC<HeaderProps> = ({
  columns,
  onSort,
  sortBy,
  sortDirection,
}) => (
  <TableHead>
    <TableRow>
      {columns.map((col) => (
        <TableCell
          key={`${col.key}-coaches-manage-table`}
          className={clsx({
            'hidden lg:table-cell': HIDE_ON_SMALL.has(col.key),
          })}
          style={
            col.sortable ? { cursor: 'pointer', userSelect: 'none' } : undefined
          }
          onClick={
            col.sortable ? () => onSort(col.key as CoachSortBy) : undefined
          }
        >
          <div className="flex items-center gap-1 whitespace-nowrap">
            <Typography variant="subtitle2">{col.label}</Typography>
            {col.sortable && sortBy === col.key && (
              <span className="material-icons text-sm">
                {sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'}
              </span>
            )}
          </div>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

export default Header;
